import React, {
  useState,
  useRef,
  useEffect,
  useCallback,
  useContext,
} from "react";
import studylistContext from "../../../../context/studylist/StudylistContext";
import { RowBadgeStatic } from "../RadiologistDetails";
import {
  Dropdown,
  TooltipHost,
  PrimaryButton,
  ContextualMenu,
  IconButton,
  Stack,
  Icon,
  Spinner,
  SpinnerSize,
} from "@fluentui/react";
import {
  assignButtonStyle,
  dropdownStyles,
  reAssignButtonStyle,
  radiologistNameStack,
  radiologistStackAssigned,
  reAssignButtonFirmStyle,
  hospitalStackStyles,
  superAdminReAssignButtonStyle,
  superAdminAssignButtonStyle,
  superAdminAssignButtonPopupStyle,
  superAdminReAssignPopUpButtonStyle,
} from "../../helpers/initData";
import CustomDropDown from "../../../../components/CustomDropDown/CustomDropDown";
import themeContext from "../../../../context/theme/ThemeContext";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import { TAB_NAME } from "../../../../constants/Constants";
import LabelsDtails from "./LabelsDetails";
import SuperAdminContextMenu from "./SuperAdminContextMenu";
import { t } from "i18next";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";
import userContext from "../../../../context/users/UserContext";

const AssignmentChainPopUp = (props) => {
  const ref = useRef(null);
  const { getThemeColor } = useContext(themeContext);
  const { onClickOutside } = props;
  const showReassignObj = props.showReassignObj;
  const [minHeightDropdown, setMinHeightDropdown] = useState("unset");
  const menuRef = useRef(null);
  const assignmentList = props.data.row.original.assignmentList;

  const {
    dataQueryState,
    setDataQueryState,
    studyListLoading,
    setStudyListLoading,
    studyListRef,
    showClientName,
    updateLockUnlockRows,
    menuForClosedAndReverted,
    setRefreshRequired,
    refreshRequired,
    setResetRowSelection,
  } = useContext(studylistContext);

  const { setAlertSuccessModal, alertSuccessModal,getConsistentDateFormat } =
    useContext(studyReportContext);

  const setHeightIncrease = (val) => {
    // console.log("--- Height ---", val);
    if (ref.current && val && val.current) {
      let divHeight = ref.current.offsetHeight;
      console.log(
        "Height of the div:",
        divHeight + "px" + val.current.offsetHeight
      );
      divHeight += val.current.offsetHeight - 20;
      setMinHeightDropdown(divHeight + "px");
    } else if (ref.current && !val) {
      setMinHeightDropdown("unset");
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && menuRef.current.contains(event.target)) {
        return;
      }

      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside && onClickOutside();
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [onClickOutside]);

  if (!props.show) return null;

  const smallSpinnerStyle = {
    circle: {
      height: "20px",
      width: "20px",
      borderWidth: "2px",
    },
    label: {
      color: "white",
    },
  };

  const getStatusOfClosedStudy = (item) => {
    if (props.tabId == TAB_NAME.UNREPORTED) {
      return false;
    }

    if (
      item?.reportDoneStatus == 2
    ) {
      return true;
    }

    let assignmentList = props.data.row.original.assignmentList;
    if (props.data.row.original.assignmentList.length > 0) {
      if (
        item?.firmId != undefined &&
        assignmentList[0].firmId === item.firmId
      ) {
        return false;
      }

      for (let i = 1; i < props.data.row.original.assignmentList.length; i++) {
        if (
          props.data.row.original.assignmentList[i]?.closed != 0 &&
          props.data.row.original.assignmentList[i]?.reportDoneStatus != 2
        ) {
          return true;
        }
      }
    }
    return true;
  };

  const getAssignmentDate = (index) => {
    const assignmentList = props.data.row.original.assignmentList;

    if (
      index == assignmentList.length - 1 && assignmentList[assignmentList.length - 1].providerId != null &&
      assignmentList[assignmentList.length - 1].providerId?.startsWith("R")
    ) {
      return getConsistentDateFormat(assignmentList[index].assignmentDateDisplay);
    }

    if (
      assignmentList[index+1] != null &&
      assignmentList[index+1] != undefined
    ) {
      return getConsistentDateFormat(assignmentList[index+1].assignmentDateDisplay);
    } else {
      return getConsistentDateFormat(assignmentList[index].assignmentDateDisplay);
    }
  };

  const handleShowLabels = (index, show) => {
    let labelDiv = document.querySelector(".label-hide-show-" + index);
    let parentDiv = document.querySelector(".studylist-label-parent");
    if (labelDiv) {
      if (show) {
        labelDiv.style.display = "flex";
      } else {
        labelDiv.style.display = "none";
      }
    }
  };

  const iconButtonStyles = {
    icon: {color: getThemeColor("primary-color"), border:"none",outline:"none"},
    root: {
      backgroundColor: 'transparent',
      selectors: {
        ':hover .ms-Button-icon': {
          color: 'white'
        },
    },
  },
    rootHovered: {backgroundColor: 'transparent'},
    rootPressed: {backgroundColor: 'transparent'}
  };

  return (
    <>
      <div
        ref={ref}
        className="assignment-chain-container assignment-chain-modal-scroll"
        style={{
          minHeight: minHeightDropdown,
          width: process.env.REACT_APP_HYBRID_MODE == "true" ? "auto" : "auto",
        }}
        // onMouseLeave={props.hideAssignments}
        onMouseEnter={()=>props.setShowAssignmentChain(true)}
      >
        <div className="study-list-super-admin-assignment-chain-container">
          <span className="study-list-super-admin-assignment-heading">
            {t("label.assignments")}
          </span>
          <span className="cancel-assignment-chain-popup"><IconButton
             style={iconButtonStyles}
            iconProps = {{iconName: 'Cancel'}}
            ariaLabel="Close popup modal"
            onClick={()=>props.setShowAssignmentChain(false)}
            /></span>
        </div>
        {!props.loadingChaining &&
          props.data.row.original.assignmentList.length > 0 &&
          props.data.row.original.assignmentList.map((item, index) => {
            return item.firmId != null && item.firmId != undefined ?
              <div key={index} className="studylist-assignment-section-a">
                {(index === assignmentList.length - 1 &&
                assignmentList[index].providerId == undefined && props.tabId !== TAB_NAME.CLOSED && assignmentList[index].closed == 0 )? (
                  <>
                    {props.data.row.depth === 0 && <SuperAdminDropDown
                      data={props.data}
                      tabId={props.tabId}
                      item={item}
                      getSelectedValue={props.getSelectedValue}
                      index={index}
                      setHeightIncrease={setHeightIncrease}
                      handleSelection={props.handleSelection}
                      unselectRadiologist = {props.unselectRadiologist}
                    />}
                  </>
                ) : (
                  (assignmentList[index].providerId == undefined || assignmentList[index]?.providerId == null) ? <></> : <RowComponent 
                     getAssignmentDate = {getAssignmentDate}
                     data = {props.data}
                     item = {item}
                     index = {index}
                  />
                )}
                {!(
                  props.data.row.original.assignmentList[0].providerId !=
                    null &&
                  props.data.row.original.assignmentList[0].closed == 0 &&
                  props.data.row.original.reportDoneStatus < 2
                ) && props.tabId === TAB_NAME.CLOSED ? (
                  <></>
                ) : (
                  index === 0 &&
                  props.data.row.original.allowAssignment && <></>
                  // <PrimaryButton
                  //   text="Revoke"
                  //   onClick={() => props.handleReassignObjectUpdate(index)}
                  //   styles={superAdminReAssignPopUpButtonStyle}
                  // />
                )}
                {props.data.row.original.assignmentList[index + 1] !=
                  undefined && (
                  <div className="studylist-super-admin-top-label">
                    <Icon
                      iconName="LabelsIcon"
                      className="studylist-label-parent"
                      onMouseEnter={() => {
                        handleShowLabels(index + 1, true);
                      }}
                      onMouseLeave={() => {
                        handleShowLabels(index + 1, false);
                      }}
                      onClick={(e) => {
                        handleShowLabels(index + 1, true);
                      }}
                    ></Icon>

                    <div
                      className={
                        `study-list-super-admin-label-container label-hide-show-` +
                        (index + 1)
                      }
                    >
                      <div className="studylist-super-admin-arrow"></div>
                      <LabelsDtails
                        index={index + 1}
                        tabId={props.tabId}
                        data={props.data}
                      />
                    </div>
                  </div>
                )}

                {props.data.row.original.assignmentList[index + 1] !=
                  undefined && (
                  <SuperAdminContextMenu
                    handleContextMenuClick={props.handleContextMenuClick}
                    getStatusOfClosedStudy={getStatusOfClosedStudy}
                    showContxtMenuForChain={props.showContxtMenuForChain}
                    handleRevertCloseStudyModal={
                      props.handleRevertCloseStudyModal
                    }
                    handleSendReport={props.handleSendReport}
                    item={props.data.row.original.assignmentList[index + 1]}
                    menuRef={menuRef}
                  />
                )}
              </div>
             : (
              props.data.row.depth === 0 && <SuperAdminDropDown
                data={props.data}
                tabId={props.tabId}
                item={item}
                getSelectedValue={props.getSelectedValue}
                index={index}
                setHeightIncrease={setHeightIncrease}
                ref={ref}
                handleSelection={props.handleSelection}
              />
            );
          })}
        {props.loadingChaining && (
          <div className="assignment-chaining-empty-spinner">
            <Spinner size={SpinnerSize.large} styles={smallSpinnerStyle} />
          </div>
        )}
      </div>
    </>
  );
};

export default AssignmentChainPopUp;


export const RowComponent = (props) => {
  const item = props.item;
  const index = props.index;
  return (<>
  <div className="studylist-assignment-header-content">
                    {/* {item.providerName != "" && item.providerName != null && item.providerName != undefined && */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {item?.providerId != undefined &&
                      item?.providerId[0] == "F" ? (
                        <RowBadgeStatic name="P" tooltipText={t("navbar.provider")} />
                      ) : (
                        <RowBadgeStatic name="R" tooltipText={t("radiologist.radiologist")} />
                      )}
                      <CustomToolTipHost
                        content={`${
                          item?.providerId != undefined &&
                          item?.providerId[0] != "F"
                            ? `${t("radiologist.radiologist")}: `
                            : props.data.row.original.assignmentList[0]
                                ?.closedByProvider
                            ? `${t("navbar.provider")}: (${t("label.closed")}) `
                            : `${t("navbar.provider")}: `
                        } ${item?.providerName}`}
                        id={"tooltip_" + item?.providerName}
                      >
                        <span
                          style={{ width: "140px", display: "block" }}
                          className="study-list-assignment-details-text 
                          studylist-assignment-text-style 
                          studylist-assignment-content-header 
                          study-list-row-badge"
                        >
                          &nbsp;{item?.closedByProvider ?`(${t("label.closed")}) ` : ""}
                          {item?.providerName == undefined
                            ? "-"
                            : item.providerName}
                        </span>
                      </CustomToolTipHost>
                    </div>
                    {/* } */}
                    {/* {returnedObjArray.length > 0 && returnedObjArray.map((ele,index)=>{
                    return ele.radiologistName == item.providerName && 
                    <span className="studylist-assignment-text-style studylist-assignment-return-text">
                    Returned on {ele.createdAt}
                  </span>
                })} */}
                    {<span className="studylist-assignment-text-style studylist-assignment-return-text">
                      {t("sorting.study-list.assignment-on")}: {props.getAssignmentDate(index)}
                    </span>}
                  </div>
  </>)
}

export const SuperAdminDropDown = (props) => {
  const { isActiveData } = useContext(userContext);
  const item = props.item;
  return (
    props.data.row.original.allowAssignment &&
    item.firmId != null &&
    props.tabId != TAB_NAME.CLOSED && (
      <React.Fragment key={props.index}>
        {
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
                marginBottom: "5px",
              }}
            >
              {/* <Dropdown
                  styles={dropdownStyles}
                  placeholder="Select Radiologist"
                  selectedKey={selected ? assignedProviderId : ""}
                  options={clientProvidersList}
                 // onClick={generateClientProviders}
                  onChange={onChange}
                  onRenderCaretDown={() =>
                    selected ? (
                      <DropdownUnselectIcon
                        unselectRadiologist={unselectRadiologist}
                      />
                    ) : (
                      <DropdownSelectIcon />
                    )
                  }
                /> */}
              <CustomDropDown
                getSelectedValue={props.getSelectedValue}
                unselectRadiologist={props.unselectRadiologist}
                index={props.index}
                data={props.data}
                placeholder={t("placeholder.select-provider-radiologist")}
                setHeightIncrease={(val) => props.setHeightIncrease(val)}
                widthSelect={"170px"}
                childRef={(ref) => {
                  props.setHeightIncrease(ref);
                }}
              />
              {/* {props.data.row.original.patientId == "01260009" && index == 0 && <CustomDropDown 
                show={true}
                setShowDropdown={setShowDropdown}
                onClickOutside={() => {
                  setShowDropdown(false);
                }}
                options={options} />} */}
              <PrimaryButton
                text={t("button.assign")}
                onClick={() => {
                  console.log("--- Assign Clicked ---");
                  props.handleSelection();
                }}
                styles={superAdminAssignButtonPopupStyle}
                disabled={!isActiveData}
              />
              {/* {
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginLeft: "18px",
                                cursor: "not-allowed",
                              }}
                            >
                              {" "}
                              <MoreIcon active={false} />
                            </div>
                          } */}
            </div>
          </div>
        }
      </React.Fragment>
    )
  );
};
